import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, mergeMap, of, switchMap } from 'rxjs';
import { ContainerActivityService } from '../_services';
import * as ContainerActivityActions from '../_actions/containerActivity';
import * as WarehouseActions from '../_actions/warehouse';

@Injectable({
  providedIn: 'root',
})
export class ContainerActivityEffects {
  loadContainerActivities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContainerActivityActions.loadContainerActivities),
      switchMap(() =>
        this.containerActivityService.getContainerActivities().pipe(
          map((containerActivities) => {
            const sorted = [...containerActivities].sort(
              (a, b) => new Date(b.activityDate).getTime() - new Date(a.activityDate).getTime()
            );
            return ContainerActivityActions.loadContainerActivitiesSuccess({
              containerActivities: sorted,
            });
          }),
          catchError((error) =>
            of(ContainerActivityActions.loadContainerActivitiesFailure({ error }))
          )
        )
      )
    )
  );

  addContainerActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContainerActivityActions.addContainerActivity),
      mergeMap(({ containerActivity }) =>
        this.containerActivityService.saveContainerActivity(containerActivity).pipe(
          map((savedContainerActivity) =>
            ContainerActivityActions.addContainerActivitySuccess({
              containerActivity: savedContainerActivity,
            })
          ),
          catchError((error) => of(ContainerActivityActions.addContainerActivityFailure({ error })))
        )
      )
    )
  );

  loadWarehousesAfterContainerActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContainerActivityActions.addContainerActivitySuccess),
      map(() => WarehouseActions.loadWarehouses())
    )
  );

  loadWarehousesAfterLoadContainerActivities$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContainerActivityActions.loadContainerActivitiesSuccess),
      map(() => WarehouseActions.loadWarehouses())
    )
  );

  loadWarehousesAfterUpdateContainerActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContainerActivityActions.updateContainerActivitySuccess),
      map(() => WarehouseActions.loadWarehouses())
    )
  );

  loadWarehousesAfterDeleteContainerActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContainerActivityActions.deleteContainerActivitySuccess),
      map(() => WarehouseActions.loadWarehouses())
    )
  );

  updateContainerActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContainerActivityActions.updateContainerActivity),
      mergeMap(({ containerActivity }) =>
        this.containerActivityService.saveContainerActivity(containerActivity).pipe(
          map((updatedContainerActivity) =>
            ContainerActivityActions.updateContainerActivitySuccess({
              containerActivity: updatedContainerActivity,
            })
          ),
          catchError((error) =>
            of(ContainerActivityActions.updateContainerActivityFailure({ error }))
          )
        )
      )
    )
  );

  deleteContainerActivity$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ContainerActivityActions.deleteContainerActivity),
      mergeMap(({ id }) =>
        this.containerActivityService.deleteContainerActivity(id).pipe(
          map(() => ContainerActivityActions.deleteContainerActivitySuccess({ id })),
          catchError((error) =>
            of(ContainerActivityActions.deleteContainerActivityFailure({ error }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private containerActivityService: ContainerActivityService
  ) {}
}
